import Cookies from 'js-cookie';
import posthog from 'posthog-js';
import ReactGA4 from 'react-ga4';

declare global {
  interface Window {
    dataLayer: Record<string, any>[];
    fbq: (command: string, event: string, data: any) => void;
  }
}

export function captureEvent (event: string, data: any) {
  // Extra data
  data = {
    ...data,
    layout: Cookies.get('sw_result_layout'),
  };

  // eslint-disable-next-line no-console
  console.log('[SWUA]', 'Capture Event:', event, data);

  // Google Analytics
  ReactGA4.event(event, data);

  // PostHog
  posthog.capture(event, data);

  // Meta Pixel
  if (window.fbq) window.fbq('trackCustom', event, data);
}
